export default __webpack_public_path__ + "static/media/kapow-kicks.472a5a09.jpg";